import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-priority-dialog',
  templateUrl: './priority-dialog.component.html',
  styleUrls: ['./priority-dialog.component.css']
})
export class PriorityDialogComponent {
  priority: string = '';

  constructor(private dialogRef: MatDialogRef<PriorityDialogComponent>) {}

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    this.dialogRef.close(this.priority);
  }
}
